import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiHttpClient } from '../../../../infrastructure/infrastructure.module';
import { camps } from '../../../models/models.generated';

@Injectable({
    providedIn: 'root',
})
export class CampImagesApiService extends ApiHttpClient {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public uploadCampCategoryPhoto(campCategoryId: string, formData: FormData): Observable<string> {
        const fullUrl = this.getUrl() + `campcategory/${campCategoryId}/photo`;
        return this.httpClient.put<camps.OperationResult>(fullUrl, formData).pipe(
            map((x: camps.OperationResult) => {
                if (x.isSuccess) {
                    const value: string = (x as any).value;
                    return value;
                } else {
                    throw new Error(x.errorMessage);
                }
            })
        );
    }

    public getCampCategoriesPhotos(campCategoriesIds: string[], width: number, height: number): Observable<camps.CampCategoryPhotoUrlModel[]> {
        const paramsObj = {
            campCategoryIds: campCategoriesIds,
            width: width,
            height: height,
        };
        const params = new HttpParams({ fromObject: paramsObj });
        const fullUrl = this.getUrl() + `campcategory/photo`;
        // const fullUrl = 'http://localhost:5292/api/1.0/campcategory/photo';
        return this.httpClient.get<camps.OperationResult>(fullUrl, { params: params }).pipe(
            map((x: camps.OperationResult) => {
                if (x.isSuccess) {
                    const value: camps.CampCategoryPhotoUrlModel[] = (x as any).value;
                    return value;
                } else {
                    throw new Error(x.errorMessage);
                }
            })
        );
    }

    public deleteCampCategoryPhoto(campCategoryId: string) {
        const fullUrl = this.getUrl() + `campcategory/${campCategoryId}/photo`;
        return this.httpClient.delete<camps.OperationResult>(fullUrl).pipe(
            map((x: camps.OperationResult) => {
                if (x.isSuccess) {
                    return;
                } else {
                    throw new Error(x.errorMessage);
                }
            })
        );
    }

    public getPhotoManagementPhoto(url: string): Observable<{ content: string; filename: string }> {
        return this.httpClient.get<string>(url).pipe(
            map((x) => {
                const apiData: { content: string; fileName: string } = (x as any).value;
                const b64 = apiData.content;
                const fileName = apiData.fileName;
                const b64Value = 'data:image/png;base64,' + b64;
                return { content: b64Value, filename: fileName };
            })
        );
    }
}
